/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * A module aggregating configurations for all modules and Node services.
 * @module configurations
 */

"use strict";

/** @requires configurations/common */

var common = require("./lib/common");

if (process.browser) {
  module.exports = common;
} else {
  module.exports = {
    common: common
  };
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/configurations/index.js
// module id = 21
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54